import { configureStore } from '@reduxjs/toolkit'
import otpReducer from './reducer/OtpReducer'
import alertReducer from './reducer/AlertReducer'
import sideBarReducer from './reducer/SideBarReducer'
import loadingReducer from './reducer/LoadingReducer'
import { AdminReducer } from './reducer/AdminReducer'
import { UserReducer } from './reducer/UserReducer'
import { TaskReducer } from './reducer/TaskReducer'
export const store = configureStore({
  reducer: {
    otp: otpReducer,
    alert: alertReducer,
    sidebar:sideBarReducer,
    loading:loadingReducer,
    admin: AdminReducer,
    user:UserReducer,
    task:TaskReducer,
   },
})
export default store;